import type { RadioTextFilterValueType } from '../../../components/StatelessComponent/SingleFilter/GenericBloc/GenericRadioTextFilter/GenericRadioTextType';
import { RadioTextFilterOperation } from '../../../components/StatelessComponent/SingleFilter/GenericBloc/GenericRadioTextFilter/GenericRadioTextType';
import type { IntermediateFormat } from '../../../domains/global-filters/model/IntermediateFormat';
import type { QueryFormatFilter } from '../../../domains/global-filters/model/QueryFormat';
import {
  QueryMapOperandEnum,
  QueryKeyEnum,
} from '../../../domains/global-filters/model/QueryFormat';

const shouldNotHappen = (never: never): void => {
  throw new Error(`Unknown type: ${never}`);
};

export function fromUiToQueryFormat(uiValue?: RadioTextFilterValueType): QueryFormatFilter {
  if (!uiValue) {
    return {};
  }
  switch (uiValue.operation) {
    case RadioTextFilterOperation.CONTAINS:
    case RadioTextFilterOperation.NOT_CONTAINS:
    case RadioTextFilterOperation.STARTS_WITH:
    case RadioTextFilterOperation.NOT_STARTS_WITH:
    case RadioTextFilterOperation.ENDS_WITH:
    case RadioTextFilterOperation.NOT_ENDS_WITH:
    case RadioTextFilterOperation.IS_UNKNOWN:
    case RadioTextFilterOperation.REGEX:
    case RadioTextFilterOperation.IS_EXACTLY:
    case RadioTextFilterOperation.IS_NOT_EXACTLY:
    case RadioTextFilterOperation.HAS_ANY_VALUE: {
      // Ignore;
      break;
    }
    case RadioTextFilterOperation.IS: {
      return { [QueryMapOperandEnum.EQUAL]: { [QueryKeyEnum.visitor_uuid]: uiValue.value } };
    }
    case RadioTextFilterOperation.IS_NOT: {
      return {
        [QueryMapOperandEnum.NOT]: {
          [QueryMapOperandEnum.EQUAL]: { [QueryKeyEnum.visitor_uuid]: uiValue.value },
        },
      };
    }
    default: {
      shouldNotHappen(uiValue);
    }
  }
  return {};
}

export function fromIntermediateToUiFormat(
  intermediateValue: IntermediateFormat,
): RadioTextFilterValueType {
  return intermediateValue.negate === true
    ? {
        operation: RadioTextFilterOperation.IS_NOT,
        value: intermediateValue.value[0] as string,
      }
    : {
        operation: RadioTextFilterOperation.IS,
        value: intermediateValue.value[0] as string,
      };
}
